import { getStatusId } from '@btime/constants'
import { identity } from 'ramda'
import { useTranslation } from 'react-i18next'

export const formatStatusOptionByName = (statusName, t = identity) => {
  const label = t(statusName)
  return {
    label,
    value: getStatusId(statusName),
    origin: { name: statusName }
  }
}

export const useStatusOptionFormatter = () => {
  const { t } = useTranslation()
  return name => formatStatusOptionByName(name, v => t('status.' + v, { count: 2 }))
}
